import Logo from "../Logo";
import React from "react";
import {useNavigate} from "react-router-dom";
import ResetPasswordForm from "../forms/ResetPasswordForm";
import styles from './ResetPasswordCard.module.css'

const ResetPasswordCard = () => {
    const navigate =  useNavigate();

    return (
        <div className={styles.container}>
            <div className={`row ${styles.cardDimensions} center`}>
                <div
                    className={`col-md-6 ${styles.leftContainer} p-5 p-md-6 d-flex flex-column justify-content-between`}>
                    <div className="pt-md-5">
                        <Logo
                            style={{width: "70px", height: "70px", borderRadius: "20px"}}
                        />
                        <h3 className="pt-4 mh-80">
                            Revolutionizing Research Publishing & Management
                        </h3>
                    </div>
                    <p>
                        Remember your password
                        <span onClick={() => navigate("/")} style={{cursor: "pointer",color:"var(--gray)"}}> Log in.</span>
                    </p>
                </div>

                <div className={`col-md-6 p-5 p-md-6 d-flex align-items-center ${styles.rightContainer}`}>
                    <ResetPasswordForm/>
                </div>
            </div>
        </div>
    )
}

export default ResetPasswordCard